import { render, staticRenderFns } from "./RoadExclusions.vue?vue&type=template&id=2072bce2&scoped=true&"
import script from "./RoadExclusions.vue?vue&type=script&lang=js&"
export * from "./RoadExclusions.vue?vue&type=script&lang=js&"
import style0 from "./RoadExclusions.vue?vue&type=style&index=0&id=2072bce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2072bce2",
  null
  
)

export default component.exports